module.exports = __webpack_public_path__ + "static/media/mapfre.2a1d0fa0.svg";